import { render, staticRenderFns } from "./GuestMobileMealsView.vue?vue&type=template&id=dc6c205a"
import script from "./GuestMobileMealsView.vue?vue&type=script&lang=js"
export * from "./GuestMobileMealsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports